import { FC, useMemo } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';
import { Icon } from '@components/icons';
import { useTranslation } from 'react-i18next';
import { EFundsOperation } from '@enum';

interface IProps {
    onClick?: () => void;
    type: EFundsOperation;
}

const cx = classNames.bind(styles);

const ChooseMethod: FC<IProps> = ({ onClick, type }) => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'send_and_request.method'
    });
    const rootStyles = useMemo(() => cx([styles.wrapper]), []);

    const renderSendMessage = () => {
        switch (type) {
            case EFundsOperation.WALLET_CREDIT_TRANSFER:
                return t('internal.description');
            case EFundsOperation.E_TRANSFER_CREDIT_TRANSFER:
                return t('e_transfer.description');
            case EFundsOperation.EFT_CREDIT_WITHDRAWAL:
                return t('bank.description');
            case EFundsOperation.E_TRANSFER_DEBIT_REQUEST:
                return t('e_transfer_request.description');
            case EFundsOperation.WALLET_DEBIT_REQUEST:
                return t('internal_request.description');
            case EFundsOperation.EFT_DEBIT_DEPOSIT:
                return t('bank_request.description');
            case EFundsOperation.EPS_DEBIT_DEPOSIT:
                return t('eps_request.description');
        }
    };

    const renderTitle = () => {
        switch (type) {
            case EFundsOperation.WALLET_CREDIT_TRANSFER:
                return t('internal.title');
            case EFundsOperation.E_TRANSFER_CREDIT_TRANSFER:
                return t('e_transfer.title');
            case EFundsOperation.EFT_CREDIT_WITHDRAWAL:
                return t('bank.title');
            case EFundsOperation.E_TRANSFER_DEBIT_REQUEST:
                return t('e_transfer_request.title');
            case EFundsOperation.WALLET_DEBIT_REQUEST:
                return t('internal_request.title');
            case EFundsOperation.EFT_DEBIT_DEPOSIT:
                return t('bank_request.title');
            case EFundsOperation.EPS_DEBIT_DEPOSIT:
                return t('eps_request.title');
        }
    };

    const getIcon = () => {
        switch (type) {
            case EFundsOperation.WALLET_CREDIT_TRANSFER:
            case EFundsOperation.WALLET_DEBIT_REQUEST:
                return 'account_balance';
            case EFundsOperation.E_TRANSFER_CREDIT_TRANSFER:
            case EFundsOperation.E_TRANSFER_DEBIT_REQUEST:
                return 'interac';
            case EFundsOperation.EFT_CREDIT_WITHDRAWAL:
            case EFundsOperation.EFT_DEBIT_DEPOSIT:
                return 'bank';
            case EFundsOperation.EPS_DEBIT_DEPOSIT:
                return 'credit_card';
            default:
                return 'bank';
        }
    };

    return (
        <div
            className={rootStyles}
            onClick={() => {
                if (onClick) onClick();
            }}>
            <div className={styles.left}>
                <div className={styles.icon}>
                    <Icon name={getIcon()} />
                </div>
                <div className={styles.text_wrapper}>
                    <Typography
                        className={styles.title}
                        variant="body1"
                        weight="semibold"
                        dangerouslySetInnerHTML={{ __html: renderTitle() || '' }}
                    />
                    <Typography
                        className={styles.description}
                        variant="body3"
                        dangerouslySetInnerHTML={{ __html: renderSendMessage() || '' }}
                    />
                </div>
            </div>
            <Icon name="nav_right" />
        </div>
    );
};

export default ChooseMethod;
